(function(){
var $=function(i){return document.getElementById(i)};
var dr=$("drawer"),mb=$("menu");
var hamburgerSVG=mb.innerHTML;
var closeSVG='<svg width="26" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 4l16 16M20 4L4 20"/></svg>';
function menu(o){dr.classList.toggle("open",o);mb.setAttribute("aria-expanded",o);mb.innerHTML=o?closeSVG:hamburgerSVG;
  document.body.style.overflow=o?"hidden":"";
  if(o)$("close").focus();else mb.focus()}
mb.addEventListener("click",function(){menu(!dr.classList.contains("open"))});
$("close").addEventListener("click",function(){menu(false)});
dr.querySelectorAll(".drawer-links a").forEach(function(a){a.addEventListener("click",function(){menu(false)})});
document.addEventListener("keydown",function(e){if(e.key==="Escape"&&dr.classList.contains("open"))menu(false)});
var so=$("sort");if(so)so.addEventListener("change",function(){location.href=(so.dataset.base||"/collections/all")+"?sort_by="+so.value});
var hero=$("hero");
if(hero){
 var S=[
  {l:"Get connected to qualified orthotists and prosthetists.",h:"Built around your body",s:"Book a consultation for a prosthesis or orthosis, then shop braces, spinal supports and running gear.",a:"Specialist pointing at a spine x-ray"},
  {l:"Lumbar, knee, ankle and posture supports.",h:"Braces and spinal support",s:"Choose a support, or book a fitting first.",a:"Athlete training with a knee brace"},
  {l:"Compression, insoles and gear for sport.",h:"Run. Train. Recover.",s:"Products picked for active people and athletes.",a:"Runner on a track"}];
 var si=0,dots=document.querySelectorAll(".car .dot"),hp=$("hp"),timer=null;
 function slide(i){si=(i+S.length)%S.length;
  $("hl").textContent=S[si].l;$("hh").textContent=S[si].h;$("hs").textContent=S[si].s;
  hp.style.backgroundImage="url("+hero.dataset["i"+(si+1)]+")";hp.setAttribute("aria-label",S[si].a);
  dots.forEach(function(d,k){d.setAttribute("aria-current",k===si?"true":"false")})}
 function play(){stop();timer=setInterval(function(){slide(si+1)},5000)}
 function stop(){if(timer){clearInterval(timer);timer=null}}
 dots.forEach(function(d,k){d.addEventListener("click",function(){slide(k);play()})});
 $("prev").addEventListener("click",function(){slide(si-1);play()});
 $("next").addEventListener("click",function(){slide(si+1);play()});
 var sx=null,sdx=0;
 hero.addEventListener("touchstart",function(e){sx=e.touches[0].clientX;sdx=0;stop()},{passive:true});
 hero.addEventListener("touchmove",function(e){if(sx!==null)sdx=e.touches[0].clientX-sx},{passive:true});
 hero.addEventListener("touchend",function(){if(Math.abs(sdx)>40){slide(sdx<0?si+1:si-1)}sx=null;play()});
 hero.addEventListener("mouseenter",stop);
 hero.addEventListener("mouseleave",play);
 hero.addEventListener("pointerdown",function(e){if(e.pointerType==="touch")return;sx=e.clientX;sdx=0});
 hero.addEventListener("pointerup",function(e){if(e.pointerType==="touch"||sx===null)return;sdx=e.clientX-sx;if(Math.abs(sdx)>40)slide(sdx<0?si+1:si-1);sx=null});
 document.addEventListener("visibilitychange",function(){if(document.hidden)stop();else play()});
 if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){slide(0);play()}else{slide(0)}
}
})();
document.querySelectorAll(".pgal").forEach(function(g){
  var main=g.querySelector(".pmain img");
  g.querySelectorAll(".thumbs img").forEach(function(t){
    t.addEventListener("click",function(){
      if(main){main.removeAttribute("srcset");main.removeAttribute("sizes");main.src=t.dataset.full||t.src}
      g.querySelectorAll(".thumbs img").forEach(function(o){o.classList.remove("on")});
      t.classList.add("on");
    });
  });
});
document.querySelectorAll(".pqty").forEach(function(q){
  var inp=q.querySelector("input");
  q.querySelector(".minus").addEventListener("click",function(){inp.value=Math.max(1,(parseInt(inp.value)||1)-1)});
  q.querySelector(".plus").addEventListener("click",function(){inp.value=(parseInt(inp.value)||1)+1});
});

(function(){
  var slides=document.querySelectorAll(".rslide");
  if(!slides.length)return;
  var dots=document.querySelectorAll("#rdots .rdot"),ri=0;
  function show(i){ri=(i+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle("on",k===ri)});
    dots.forEach(function(d,k){d.setAttribute("aria-current",k===ri?"true":"false")});
  }
  dots.forEach(function(d,k){d.addEventListener("click",function(){show(k)})});
  document.getElementById("rprev").addEventListener("click",function(){show(ri-1)});
  document.getElementById("rnext").addEventListener("click",function(){show(ri+1)});
})();

document.querySelectorAll(".cremove").forEach(function(btn){
  btn.addEventListener("click", function(){
    var row = this.closest(".crow");
    var qty = row && row.querySelector('input[type="number"]');
    if(qty) qty.value = 0;
  });
});

(function(){
  var tabs = document.querySelectorAll(".gtab");
  if(!tabs.length) return;
  var items = document.querySelectorAll(".gitem");
  function apply(cat){
    tabs.forEach(function(t){t.setAttribute("aria-selected", t.dataset.cat===cat ? "true":"false")});
    items.forEach(function(it){it.classList.toggle("show", it.dataset.cat===cat)});
  }
  tabs.forEach(function(t){t.addEventListener("click", function(){apply(t.dataset.cat)})});
  apply(tabs[0].dataset.cat);
})();

(function(){
  var bar=document.getElementById("promo");if(!bar)return;
  var main=document.getElementById("promo-main"),cd=document.getElementById("promo-cd"),t=document.getElementById("promo-t");
  if(bar.dataset.mode!=="countdown")return;
  var m=(bar.dataset.end||"").match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if(!m)return;
  // end time is South Africa time (UTC+2, no daylight saving)
  var end=Date.UTC(+m[1],+m[2]-1,+m[3],+m[4]-2,+m[5]);
  var tick;
  function pad(n){return n<10?"0"+n:""+n}
  function run(){
    var left=end-Date.now();
    if(left<=0){cd.hidden=true;main.hidden=false;if(tick)clearInterval(tick);return}
    var s=Math.floor(left/1000);
    t.textContent=pad(Math.floor(s/3600))+":"+pad(Math.floor(s%3600/60))+":"+pad(s%60);
    cd.hidden=false;main.hidden=true;
  }
  run();tick=setInterval(run,1000);
})();

(function(){
  document.querySelectorAll(".bundle").forEach(function(b){
    var form=b.closest("form");if(!form)return;
    var qty=form.querySelector("input[name=quantity]"),sel=form.querySelector("select[name=id]"),hid=form.querySelector("input[type=hidden][name=id]");
    var data={};try{data=JSON.parse(b.dataset.prices)}catch(e){}
    var cards=b.querySelectorAll(".bcard");
    function vid(){return sel?sel.value:(hid?hid.value:"")}
    function sync(){var cur=b.querySelector("input:checked");if(!cur)return;
      cards.forEach(function(c){c.classList.toggle("on",c.contains(cur))});qty.value=cur.value}
    function render(){var d=data[vid()];if(d){
      cards.forEach(function(c){var q=c.dataset.qty,p=c.querySelector(".bp"),w=c.querySelector(".bw"),i=c.querySelector("input");
        if(p)p.textContent=d["t"+q];if(w)w.textContent=d["w"+q]||"";
        var off=d.max<+q;c.classList.toggle("off",off);i.disabled=off});
      var cur=b.querySelector("input:checked");if(cur&&cur.disabled)cards[0].querySelector("input").checked=true}
      sync()}
    b.addEventListener("change",sync);if(sel)sel.addEventListener("change",render);render();
  });
  var cutEl=document.getElementById("pcut"),cutS=0,late=false;
  if(cutEl){var cp=(cutEl.dataset.cutoff||"14:00").split(":");cutS=(+cp[0]*3600)+((+cp[1]||0)*60)}
  function saNow(){var n=new Date(Date.now()+7200000);return{day:n.getUTCDay(),s:n.getUTCHours()*3600+n.getUTCMinutes()*60+n.getUTCSeconds()}}
  function pad(x){return (x<10?"0":"")+x}
  function tick(){
    var n=saNow(),open=n.day>=1&&n.day<=5&&n.s<cutS;
    if(cutEl){
      if(open){var r=cutS-n.s,h=Math.floor(r/3600),m=Math.floor(r%3600/60),sec=r%60;
        cutEl.innerHTML="<i></i>Order within <b>"+(h?h+"h ":"")+pad(m)+"m "+pad(sec)+"s</b> for same-day dispatch"}
      else cutEl.innerHTML="<i></i>Order now and it dispatches on the next business day";
      cutEl.hidden=false}
    return !open}
  late=tick();
  if(cutEl)setInterval(function(){late=tick()},1000);
  function addBiz(n){var d=new Date();while(n>0){d.setDate(d.getDate()+1);var g=d.getDay();if(g!==0&&g!==6)n--}return d}
  function fmt(d){return d.toLocaleDateString("en-GB",{weekday:"short",day:"numeric",month:"short"})}
  [["pdeliv","Standard delivery (free): "],["pdeliv-x","Express delivery (R120): "]].forEach(function(x){
    var dl=document.getElementById(x[0]);
    if(dl){try{var k=late?1:0;dl.textContent=x[1]+fmt(addBiz(+dl.dataset.min+k))+" to "+fmt(addBiz(+dl.dataset.max+k))}catch(e){}}
  });

  (function(){
    var el=document.getElementById("psale");if(!el)return;
    var m=(el.dataset.end||"").match(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/);if(!m)return;
    var end=Date.UTC(+m[1],+m[2]-1,+m[3],+m[4]-2,+m[5]),t=document.getElementById("psale-t");
    function p(x){return (x<10?"0":"")+x}
    function run(){var r=Math.floor((end-Date.now())/1000);
      if(r<=0){el.hidden=true;return false}
      var d=Math.floor(r/86400),h=Math.floor(r%86400/3600),mi=Math.floor(r%3600/60),sc=r%60;
      t.textContent="ends in "+(d?d+"d ":"")+p(h)+"h "+p(mi)+"m "+p(sc)+"s";el.hidden=false;return true}
    if(run()){var iv=setInterval(function(){if(!run())clearInterval(iv)},1000)}
  })();
})();
